import { PROP_CHALLENGE_PHASE_VARIANTS, PropChallengePhaseVariant } from 'constants/prop-challenge.constants';

export interface FundedStepTexts {
    headerKey: string;
    subTextKey: string;
    buttonKey: string;
}

export const FUNDED_STEP_TEXTS: Record<PropChallengePhaseVariant, FundedStepTexts> = {
    [PROP_CHALLENGE_PHASE_VARIANTS.FUNDED]: {
        headerKey: 'investingManualKyc.NotStarted.header',
        subTextKey: 'investingManualKyc.NotStarted.subTxt',
        buttonKey: 'investingManualKyc.NotStarted.btn',
    },
    [PROP_CHALLENGE_PHASE_VARIANTS.AUDITION_FIRST]: {
        headerKey: 'investingManualKyc.modalAuditionFirst.modal_audition_first_title',
        subTextKey: 'investingManualKyc.modalAuditionFirst.modal_audition_first_content',
        buttonKey: 'investingManualKyc.modalAuditionFirst.modal_audition_first_cta',
    },
    [PROP_CHALLENGE_PHASE_VARIANTS.AUDITION_NEXT]: {
        headerKey: 'investingManualKyc.modalAuditionNotFirst.modal_audition_not_first_title',
        subTextKey: 'investingManualKyc.modalAuditionNotFirst.modal_audition_not_first_content',
        buttonKey: 'investingManualKyc.modalAuditionNotFirst.modal_audition_not_first_cta',
    },
};

export const resolveFundedStepVariant = (
    isAudition?: boolean,
    isFirstAudition?: boolean
): PropChallengePhaseVariant => {
    if (!isAudition) {
        return PROP_CHALLENGE_PHASE_VARIANTS.FUNDED;
    }

    return isFirstAudition ? PROP_CHALLENGE_PHASE_VARIANTS.AUDITION_FIRST : PROP_CHALLENGE_PHASE_VARIANTS.AUDITION_NEXT;
};
